import React from "react";
// import './levelControls.css';

const LevelButton = ({ name, id, currentLevelId, isMobile }) => {
  if (currentLevelId === id) {
    return name ? (
      <div
        className={isMobile ? "level-btn-active-mobile" : "level-btn-active"}
        id={id}
      >
        <div className="level-name">
          {name.toString().split("")[0]}
          <sup>{name.toString().split("")[1]}</sup>
        </div>
      </div>
    ) : null;
  }
  return name ? (
    <div className={isMobile ? "level-btn-mobile" : "level-btn"} id={id}>
      <div className="level-name">
        {name.toString().split("")[0]}
        <sup>{name.toString().split("")[1]}</sup>
      </div>
    </div>
  ) : null;
};

const LevelControls = ({
  levels,
  userFloor,
  currentFloor,
  isMobile,
  onLevelChanged,
}) => {
  return levels.map((level) => {
    if (level.id === userFloor) {
      return (
        <div
          className="level-btn-wrapper"
          key={level.id}
          id={level.id}
          onClick={onLevelChanged}
        >
          <LevelButton
            name={level.name}
            id={level.id}
            currentLevelId={currentFloor}
            isMobile={isMobile}
          />
        </div>
      );
    }
    return (
      <div
        className="level-btn-wrapper"
        key={level.id}
        id={level.id}
        onClick={onLevelChanged}
      >
        <LevelButton
          name={level.name}
          id={level.id}
          currentLevelId={currentFloor}
          isMobile={isMobile}
        />
      </div>
    );
  });
};

export default LevelControls;



// WEBPACK FOOTER //
// ./src/components/LevelControls/LevelControls.js